import React from 'react';

import { Button, ButtonProps } from '../button/Button';

const ModalButton: React.FC<Omit<ButtonProps<{}>, 'size'>> = ({ ...props }) => (
  <Button {...props} size="lg" />
);

export default ModalButton;
